module.exports = {"id":"205402","name":"Jean-Paul Boëtius","rating":"75","photo":"./data/images/photos/2/205402.png","club":{"name":"Feyenoord","logo":"./data/images/clubs/Feyenoord.png"},"positions":["AG","AD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/Jean-PaulBoetius0.json
// module id = 1956
// module chunks = 0